import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ISnackBar {
  open: boolean;
  messageInfo: string;
}
const initialState: ISnackBar = {
  open: false,
  messageInfo: '',
};

export const snackBarSlice = createSlice({
  name: 'snackBar',
  initialState: initialState,
  reducers: {
    setShowNotification: (state, action: PayloadAction<string>) => {
      const message = action.payload.trim();
      if (!message) {
        state.open = false;
        state.messageInfo = '';
        return;
      }
      if (state.open && state.messageInfo === message) {
        return;
      }
      state.messageInfo = message;
      state.open = true;
    },
    closeNotification: (state) => {
      state.open = false;
      state.messageInfo = '';
    },
  },
});

export const { setShowNotification, closeNotification } = snackBarSlice.actions;
export default snackBarSlice.reducer;
